import React from 'react';
import { Search } from 'lucide-react';
export function Footer() {
  return <footer className="py-10 px-4" style={{
    backgroundColor: '#000000',
    borderTop: '1px solid #1a1a1a'
  }} data-id="element-125">
      <div className="max-w-2xl mx-auto text-center" data-id="element-126">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-127">
          <Search size={20} style={{
          color: '#c0392b'
        }} data-id="element-128" />
          <span className="text-lg font-bold text-white tracking-wider" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-129">
            DETECTIVE POR 1 DÍA
          </span>
        </div>

        <p className="text-gray-600 text-sm mb-6 italic" data-id="element-130">
          "Vive la experiencia del detective"
        </p>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-131">
          {['Política de privacidad', 'Términos y condiciones', 'Contacto'].map(link => <a key={link} href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors" data-id="element-132">
                {link}
              </a>)}
        </div>

        {/* Copyright */}
        <p className="text-gray-700 text-xs" data-id="element-133">
          © 2024 Detective Cases. Todos los derechos reservados.
        </p>

        {/* Decorative */}
        <div className="w-16 h-px mx-auto mt-6" style={{
        backgroundColor: '#c0392b'
      }} data-id="element-134" />
      </div>
    </footer>;
}